import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import Tooltip from '@src/components/Tooltip';
import { COLOR } from '@src/styles/color';
import { DEFAULT_DURATION_WAIT_COPY_BUTTON } from '@src/constants';
import { useTranslation } from 'react-i18next';
import CommonButton from '..';

const CopyButton = ({
  content,
  iconCopy,
  iconCopied,
  size = 32,
  variant = 'outlined',
  copyText = 'copy',
  copiedText = 'copiedv2',
  placementTooltip = 'top',
  isShowTooltip = true,
  customStyle,
}) => {
  const [copied, setCopied] = useState(false);
  const { t } = useTranslation();

  const handleClickCopy = (e) => {
    e.stopPropagation();
    if (content) {
      navigator.clipboard.writeText(content);
      setCopied(true);
    }
  };

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, DEFAULT_DURATION_WAIT_COPY_BUTTON);
    }
  }, [copied]);

  return (
    <Box>
      {!copied && (
        <Tooltip
          title={t(copyText)}
          placement={placementTooltip}
          arrow
          disableInteractive
          disableHoverListener={!isShowTooltip}
          borderRadius="8px"
        >
          <Box onClick={(e) => handleClickCopy(e)}>
            <CommonButton
              variant={variant}
              size="small"
              startIcon={iconCopy}
              customStyle={{
                marginRight: '0px',
                '& .MuiButton-startIcon': {
                  margin: '0px',
                },
                borderColor: COLOR.indigo[16],
                width: `${size}px`,
                height: `${size}px`,
                minWidth: `${size}px`,
                borderRadius: '8px',
                '&:hover': {
                  borderColor: COLOR.indigo[16],
                },
                ...customStyle,
              }}
            />
          </Box>
        </Tooltip>
      )}
      {copied && (
        <Tooltip
          title={t(copiedText)}
          placement={placementTooltip}
          arrow
          disableInteractive
          disableHoverListener={!isShowTooltip}
          borderRadius="8px"
        >
          <Box>
            <CommonButton
              variant={variant}
              size="small"
              startIcon={iconCopied}
              customStyle={{
                marginRight: '0px',
                '& .MuiButton-startIcon': {
                  margin: '0px',
                },
                borderColor: COLOR.indigo[16],
                width: `${size}px`,
                height: `${size}px`,
                minWidth: `${size}px`,
                borderRadius: '8px',
                '&:hover': {
                  borderColor: COLOR.indigo[16],
                },
                ...customStyle,
              }}
            />
          </Box>
        </Tooltip>
      )}
    </Box>
  );
};

export default CopyButton;
